module.exports = __webpack_public_path__ + "static/media/Web-application-support.0df0cafe.png";